import axios from './http';
import { CancelTokenSource } from 'axios';
import { MandateBankDto } from 'ts-types/api.types';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/mandate-banks`;

export const getAllMandateBanksByMandateId = (mandateId: number, source: CancelTokenSource): Promise<Array<MandateBankDto>> => {
  return axios
      .get(`${apiUri}/${mandateId}`, { cancelToken: source.token })
      .then(response => response.data);
};
